import { useState, useEffect } from "react";
import SettingsApi from "../httpClients/SettingsApi";

const DEFAULT_COLOR_OPTIONS = [
  { key: "lefty", hex: "#ec2735" },
  { key: "righty", hex: "#000000" },
  { key: "switch", hex: "#33aaff" },
];

const DEFAULT_SETTINGS = {
  colorOptions: DEFAULT_COLOR_OPTIONS,
  logoTransparency: 0.25,
  lastNameOnly: false,
  fullWidthImage: false,
};

const useCardSettings = () => {
  const [cardSettings, setCardSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    SettingsApi.getCardSettings()
      .then((data) => {
        setCardSettings({
          colorOptions: [
            { key: "lefty", hex: data.leftyColor || "#ec2735" },
            { key: "righty", hex: data.rightyColor || "#000000" },
            { key: "switch", hex: data.switchHitterColor || "#33aaff" },
          ],
          logoTransparency: data.logoTransparency ?? 0.25,
          lastNameOnly: data.lastNameOnly ?? false,
          fullWidthImage: data.fullWidthImage ?? false,
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { cardSettings, loading };
};

export default useCardSettings;
